export default "/img/PR.4235381d25b725dac7354c019379d20c.png";